import React from 'react';
import Slider from 'react-slick';
import { Image } from 'react-bootstrap';
import { BsStarFill } from 'react-icons/bs';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './GigReviews.css';
import '../App.css';
import servicesData from './ServiceData';

const GigReviews = ({ serviceId }) => {
    // Retrieve reviews based on the serviceId
    const service = servicesData.find(service => service.id === serviceId);
    const reviews = service ? service.reviews : [];

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    arrows: false
                }
            }
        ]
    };

    return (
        <div className="review-section-margn">
            <div className="review-sectiong">
                <Slider {...settings}>
                    {reviews.map((review, index) => (
                        <div key={index} className="review-cardg">
                            <div className="review-content">
                                <div className="image-column">
                                    <Image src={review.clientImage} roundedCircle className="client-imageg" />
                                </div>
                                <div className="text-column">
                                    <h3 className="client-nameg">{review.clientName}</h3>
                                    <p className="client-reviewg">{review.clientReview}</p>
                                </div>

                            </div>
                            <div className="starsg">
                                {[...Array(5)].map((_, i) => (
                                    <BsStarFill key={i} className={i < review.rating ? 'star-filled' : 'star-unfilled'} />
                                ))}
                            </div>
                        </div>
                    ))}
                </Slider>
            </div>
        </div>
    );
};

export default GigReviews;
